import { makeAutoObservable } from 'mobx';
import { getCanDuihuanAwardList, getDrawList, getMyPoints, getSignList, getTaskInfo } from "@/api/fiveYears";
import { getUserProfile } from '@/api/xt-console';

const hasKnowUsdtAgrLocalKey = 'hasKnowUsdtAgrLocalKey';

export default class FiveYearsAnniversaryModal {
  isRealName = false;
  monthDaysConfig = [];
  myPoints = 0;
  taskInfo = {};
  activityProfile = {};
  hasKnowUsdtAgr = false;
  noticesList = [];
  activityInfo = {};
  canDuihuanAwardList = [];
  taskModalRef = null;

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  init() {
    const knowUsdtAgr = localStorage.getItem(hasKnowUsdtAgrLocalKey) == 'true';
    this.hasKnowUsdtAgr = knowUsdtAgr;
  }

  setTaskModalRef(target) {
    this.taskModalRef = target;
  }

  setActivityInfo(info) {
    this.activityInfo = info;
  };

  setHasKnowUsdtAgr(val: boolean) {
    this.hasKnowUsdtAgr = val;
    localStorage.setItem(hasKnowUsdtAgrLocalKey, JSON.stringify(val));
  }

  *getMonthDaysConfig() {
    const result = yield getSignList();

    this.monthDaysConfig = result;
  }

  *getDuihuanAwardList() {
    const list = yield getCanDuihuanAwardList();

    this.canDuihuanAwardList = list || [];
  };

  *getMyPoints() {
    const result = yield getMyPoints();

    this.myPoints = result;
  }

  *getTaskInfo() {
    const result = yield getTaskInfo();

    this.taskInfo = result;
  }

  *getActivityProfile() {
    const result = yield getUserProfile();

    this.activityProfile = result;
  }

  *getNoticesList() {
    const result = yield getDrawList();

    this.noticesList = result;
  }
}